import { useNavigate } from 'react-router';

import { LinkIcon } from '@/components/icons/drugomaniya';
import { WayToEarnBlock } from '@/components/Profile/LoyaltyProgram/WayToEarnBlock/WayToEarnBlock.tsx';
import { PageHeading } from '@/components/shared/PageHeading/PageHeading.tsx';
import { appRoutes } from '@/routes/app-routes.ts';
import { useAuthStore, useModalStore } from '@/store';

import cn from './styles.module.sass';

const steps1 = [
    {
        stepNumber: 1,
        description: (
            <span>
                Выбери для друга номер в разделе
                <br />
                Красивые номера или Выгодные тарифы
            </span>
        ),
    },
    {
        stepNumber: 2,
        description: <span>Заполни необходимые поля и нажми Оплатить</span>,
    },
    {
        stepNumber: 3,
        description: (
            <span>
                После оплаты и успешного включения номера,
                <br />
                ты получишь 100 Б (1 Б = 1 руб.)
            </span>
        ),
    },
    {
        stepNumber: 4,
        description: (
            <span>
                Чтобы получать по 100 Б ежемесячно за каждый проданный номер, напоминай друзьям
                оплачивать тариф
            </span>
        ),
    },
];

const steps2 = [
    {
        stepNumber: 1,
        description: <span>Копируй ссылку для приглашения друга</span>,
    },
    {
        stepNumber: 2,
        description: <span>Отправь удобным способом</span>,
    },
    {
        stepNumber: 3,
        description: (
            <span>
                После первой продажи друга ты начнешь
                <br />
                получать по 2% от его дохода каждый месяц
            </span>
        ),
    },
];

export const LoyaltyProgram = () => {
    const { isAuth } = useAuthStore();

    const { setIsInviteOpen, setIsOpen, setShowSignUp } = useModalStore();

    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate(appRoutes.mainPage);
    };

    const handleOpenInvite = () => {
        if (isAuth) {
            setIsInviteOpen(true);
        } else {
            setShowSignUp(false);
            setIsOpen(true);
        }
    };

    return (
        <div className={cn.container}>
            <PageHeading pageName="2 способа зарабатывать" backToPrevLocation />
            <div className={cn.waysToEarnContainer}>
                <WayToEarnBlock
                    wayNumber={1}
                    onClick={handleNavigate}
                    wayDescription="Продавай номера самостоятельно"
                    imgSrc="/images/icons/stacked_coins.svg"
                    steps={steps1}
                    btnText="Выбрать номер"
                />
                <WayToEarnBlock
                    onClick={handleOpenInvite}
                    wayNumber={2}
                    wayDescription="Приглашай друзей и получай % от их заработка"
                    imgSrc="/images/main/wave.svg"
                    steps={steps2}
                    btnText={
                        <span>
                            <span className={cn.linkIcon}>{LinkIcon}</span>Пригласи друга
                            зарабатывать
                        </span>
                    }
                />
            </div>
        </div>
    );
};
